import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { MatIconRegistry } from '@angular/material/icon';
import { filter, first, from, of } from 'rxjs';

import { svgIconsConfig } from './app.icons-config';
import { FingerprintService, HighchartsService, LayoutService } from './shared/services';
import * as FingerprintJS from '@fingerprintjs/fingerprintjs-pro';
import { AppConfig } from '@app/app.config';
import { catchError } from 'rxjs/operators';

@Component({
    selector: 'app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent {
    constructor(
        private matIconRegistry: MatIconRegistry,
        private sanitizer: DomSanitizer,
        private layoutService: LayoutService,
        private router: Router,
        private highchartsService: HighchartsService,
        private appConfig: AppConfig,
        private fingerprintService: FingerprintService,
    ) {
        this.registerIcons();
        this.highchartsService.init();

        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                first(),
            )
            .subscribe(() => this.layoutService.hideSplashScreen());
        this.loadFingerprintJs();
    }

    private registerIcons(): void {
        let registry = this.matIconRegistry;

        Object.entries(svgIconsConfig).forEach(([name, fileName]) => {
            registry = registry.addSvgIcon(
                name,
                this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${fileName}`),
            );
        });
    }

    private loadFingerprintJs(): void {
        const fingerprintPublicKey = this.appConfig.settings?.settings?.fingerprint_id as string;

        from(
            FingerprintJS.load({
                apiKey: fingerprintPublicKey,
                endpoint: 'https://metrics.adclarity.com',
                scriptUrlPattern: 'https://metrics.adclarity.com/web/v<version>/<apiKey>/loader_v<loaderVersion>.js',
            }),
        )
            .pipe(
                catchError((e) => {
                    console.error(e);
                    this.fingerprintService.initMethod(() => of(null));
                    return of(null);
                }),
            )
            .subscribe((result) => this.fingerprintService.initMethod(result.get.bind(result)));
    }
}
